<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card width="800px">
        <v-toolbar color="blue white--text darken-3" flat>
          <v-toolbar-title>Visualizacion de la factura.</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pt-0">
          <object v-if="base64" :data="base64" width="100%" height="950px" />
          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>

        <div v-if="!loading" class="text-center my-4">
          <p class="text-center ma-0">
            <small
              ><b>Factura emitida en modo: </b> <span> {{ getTipoEmision(factura.tipoEmision) }} </span></small
            >
          </p>
          <a :href="factura.qr" target="_blank"> Click aqui para ver en <b>SIAT</b> </a>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <a
            :download="filename"
            :href="base64"
            color="primary"
            class="btn"
            :disabled="loading"
            small
            rounded
            title="Descargar"
          >
            <v-icon class="mr-1"> mdi-printer</v-icon>
            Descargar
          </a>
          <v-btn
            color="red"
            v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14"
            :disabled="loading"
            dark
            small
            tile
            @click="abrirAnularFactura()"
          >
            <v-icon class="mr-1"> mdi-file-cancel</v-icon> Anular Factura
          </v-btn>
          <v-btn
            color="green"
            v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25"
            :disabled="loading"
            dark
            small
            tile
            @click="preenvio()"
          >
            <v-icon class="mr-1"> mdi-file-cancel</v-icon> Reenviar Factura
          </v-btn>
          <v-btn color="blue darken-1" outlined tile @click="dialog = !dialog">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Anular ref="anularfactura" v-on:anuladofact="anuladofact" />
  </v-row>
</template>

<script>
  import xaxios from '@/xaxios';
  import Anular from '@/views/recibos/AnularFE.vue';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        base64: null,
        msg: '',
        factura: { qr: null },
      };
    },
    components: { Anular },
    watch: {},
    computed: {
      filename() {
        let f = 'fffff'
        if(this.factura) f = 'Factura-' + (this.factura.nombreRazonSocial + '').replaceAll('.', '_');
        return f;
      },
    },
    methods: {
      async openmodal(data) {
        window.console.log(':::verfactura::::', data);
        this.dialog = true;
        this.base64 = null;
        this.msg = '';
        this.factura = { qr: null };
        if (data.venta) this.getFacturaData(data.venta.id, data.xapikey);
      },
      getTipoEmision(tipo) {
        if (tipo == 1) return 'Online';
        else return 'Offline';
      },
      anuladofact() {
        this.dialog = false;
      },
      abrirAnularFactura() {
        this.$refs.anularfactura.openmodal(this.factura);
      },
      getFacturaData(factura_id, xapikey) {
        if(!xapikey){
          this.$root.$notify.show(`No hay apikey`, {color:'red',x: 'right',});
          return
        }
        // let xa = xapikey ? xapikey : this.$store.getters.getApiKey;
        let xa = xapikey;
        window.console.log('apikey enviado al ver: ', xa);
        this.loading = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/${factura_id}`,
          headers: {
            'Content-Type': 'application/json',
            apikey: xapikey ? xapikey : this.$store.getters.getApiKey,
            // apikey: xapikey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('getFacturaData:::: ', data);
            vue.base64 = 'data:application/pdf;base64,' + data.facturaDocumento + '#toolbar=0';
            vue.factura = data.Venta;
            if(!vue.factura) vue.factura = data.venta;
            vue.factura.xbase64 = data.facturaDocumento;
            // vue.factura.qr = `${process.env.VUE_APP_FACT_QR_SIN}/QR?nit=${vue.factura.nit}&cuf=${vue.factura.cuf}&numero=${vue.factura.numeroFactura}&t=2`;
            vue.factura.qr = vue.factura.urlSiat;
            // window.console.log('>>>',vue.factura);
            vue.loading = false;
          })
          .catch(function(error) {
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data, mensaje);
            vue.$root.$notify.show(mensaje, { color: 'red' });
            vue.loading = false;
          });
      },
      preenvio() {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
          okText: 'Si De una :)',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar Reenvio de Factura',
          body: `<br> <b>NOTA:</b> Se reenviara la factura al correo del cliente: <br> <br> <b>${this.factura.email}</b>`,
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.reenviarFacturaCorreo(dialog);
          })
          .catch(function() {});
      },
      reenviarFacturaCorreo(dialog) {
        this.loading = true;
        let vue = this;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/email/reenviar`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: {
            //facturaBase64: null,
            facturaID: this.factura.id,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            //window.console.log('reenviarFacturaCorreo:::: ', data);
            vue.$root.$notify.show(data, { color: 'success' });
            vue.loading = false;
            dialog.close();
          })
          .catch(function(error) {
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data, mensaje);
            vue.$root.$notify.show(mensaje, { color: 'red' });
            vue.loading = false;
            dialog.close();
          });
      },
    },
    mounted() {},
  };
</script>

<style></style>
